export default __webpack_public_path__ + "static/media/download_icon.f2083efc.svg";